import { useState, useEffect } from 'react';
import { useFeedback } from '../../hooks/useFeedback';

const CATEGORIAS = [
  { valor: 'bug', emoji: '🐞', label: 'Reportar bug' },
  { valor: 'sugestao', emoji: '💡', label: 'Sugestão de funcionalidade' },
  { valor: 'desafio', emoji: '🏆', label: 'Sugerir desafio' },
  { valor: 'conteudo', emoji: '📚', label: 'Sugerir conteúdo ou aula' },
  { valor: 'elogio', emoji: '🙌', label: 'Elogio' },
  { valor: 'outro', emoji: '💬', label: 'Outro' },
];

export default function ModalFeedback({ visivel, onFechar }) {
  const [tipo, setTipo] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const { enviar, loading, sucesso, resetar } = useFeedback();

  // Fecha automaticamente 2s após sucesso
  useEffect(() => {
    if (sucesso) {
      const t = setTimeout(() => {
        handleFechar();
      }, 2000);
      return () => clearTimeout(t);
    }
  }, [sucesso]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFechar = () => {
    setTipo(null);
    setMensagem('');
    resetar();
    onFechar();
  };

  const handleEnviar = async () => {
    if (!tipo || !mensagem.trim()) return;
    await enviar({ tipo, mensagem: mensagem.trim() });
  };

  if (!visivel) return null;

  return (
    <div className="modal-feedback-backdrop" onClick={(e) => { if (e.target === e.currentTarget) handleFechar(); }}>
      <div className="modal-feedback-card">
        {sucesso ? (
          <div className="modal-feedback-sucesso">
            <span className="modal-feedback-sucesso-emoji">💜</span>
            <p className="modal-feedback-sucesso-texto">Obrigada! Sua voz importa muito.</p>
          </div>
        ) : (
          <>
            <div className="modal-feedback-header">
              <h3 className="modal-feedback-titulo">Fale com a gente</h3>
              <button className="modal-feedback-fechar" onClick={handleFechar} aria-label="Fechar">✕</button>
            </div>
            <p className="modal-feedback-descricao">Selecione o tipo de mensagem:</p>

            <div className="modal-feedback-chips">
              {CATEGORIAS.map((cat) => (
                <button
                  key={cat.valor}
                  className={`modal-feedback-chip${tipo === cat.valor ? ' ativo' : ''}`}
                  onClick={() => setTipo(cat.valor)}
                >
                  <span>{cat.emoji}</span> {cat.label}
                </button>
              ))}
            </div>

            <textarea
              className="modal-feedback-textarea"
              placeholder="Escreva sua mensagem aqui..."
              value={mensagem}
              onChange={(e) => setMensagem(e.target.value)}
              rows={4}
              maxLength={1000}
            />

            <button
              className="btn btn-primary"
              style={{ width: '100%', marginTop: 8 }}
              onClick={handleEnviar}
              disabled={!tipo || !mensagem.trim() || loading}
            >
              {loading ? 'Enviando...' : 'Enviar'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
